export class SourceStorageBackupStatus {
    'data';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<VisualizationLabel>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SourceStorageBackupStatus.attributeTypeMap;
    }
    constructor() {
    }
}
